import {
  CashOption,
  PaymentType,
  ProductType,
  SchemaTypes,
} from '@allesauto/graphql';
import { ACCESSORY_STANDALONE_CART_SKU } from '@allesauto/utils/consts';

const accessoryStandaloneToCartItemInput = (
  accessoryProductId: string,
  accessoryDealerId: string,
  dealerId: string
): SchemaTypes.CartItemInput => {
  return {
    sku: ACCESSORY_STANDALONE_CART_SKU,
    productType: ProductType.AccessoryStandAlone,
    quantity: 1,
    dealerId,
    accessoryOptions: {
      dealerId: accessoryDealerId,
      productId: accessoryProductId,
    },
    paymentOptions: {
      paymentType: PaymentType.CashRange,
      cashOption: CashOption.Prepayment,
    },
  };
};

export default accessoryStandaloneToCartItemInput;
